import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalWarningComponent } from './modal-warning.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { FlexLayoutModule } from '@angular/flex-layout';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
      MatCardModule,
      CommonModule,
      FlexLayoutModule,
      MatButtonModule,
      MatButtonToggleModule,
      MatInputModule,
      MatToolbarModule,
      FormsModule,
      ReactiveFormsModule,
      MatIconModule,
      MatRadioModule,
      MatDialogModule
  ],
  declarations: [
    ModalWarningComponent,
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    }
  ]
})

export class ModalWarningModule { }
